import { useSyncExternalStore } from 'react'
import { Volume2, VolumeX } from 'lucide-react'
import { Button } from './ui/button'
import { subscribeVideo, getMuted, setMuted, getVideoIds } from '../video'

export function AudioToggle() {
  const ids = useSyncExternalStore(subscribeVideo, getVideoIds, () => [] as string[])
  const muted = useSyncExternalStore(subscribeVideo, getMuted, () => true)

  if (ids.length === 0) return null

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={muted ? 'Activar audio del video' : 'Silenciar video'}
      onClick={() => setMuted(!muted)}
    >
      {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
    </Button>
  )
}
